import { Box, IconButton, Stack, Typography } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { StoredAlias } from '../reducer';

type MappedAliasesProps = {
  storedAliases: StoredAlias[];
  pendingVendorTitle: string | null;
  onDeleteStored: (alias: StoredAlias) => void;
  onDeletePending: () => void;
};

const MappedAliases = ({ storedAliases, pendingVendorTitle, onDeleteStored, onDeletePending }: MappedAliasesProps) => (
  <Box
    sx={{
      position: 'absolute',
      inset: 0,
      border: '1px solid',
      borderColor: 'divider',
      borderRadius: 1,
      boxSizing: 'border-box',
      overflowY: 'auto',
      p: 1.5,
    }}
  >
    <Stack gap={0.5}>
      {storedAliases.map((alias) => (
        <Box key={alias.id} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>
          <Typography variant="caption" sx={{ overflowWrap: 'anywhere' }}>
            {alias.vendorTitle}
          </Typography>
          <IconButton aria-label="delete alias" size="small" onClick={() => onDeleteStored(alias)}>
            <DeleteIcon fontSize="small" />
          </IconButton>
        </Box>
      ))}
      {pendingVendorTitle != null && (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>
          <Typography variant="caption" sx={{ overflowWrap: 'anywhere' }}>
            {pendingVendorTitle}
          </Typography>
          <IconButton aria-label="remove pending alias" size="small" onClick={onDeletePending}>
            <DeleteIcon fontSize="small" />
          </IconButton>
        </Box>
      )}
    </Stack>
  </Box>
);

export default MappedAliases;
